import { render } from "./LeftMenuSocial.vue?vue&type=template&id=5dc54518"
import script from "./LeftMenuSocial.vue?vue&type=script&lang=js"
export * from "./LeftMenuSocial.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__